import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlParse',
  standalone: false,
})
export class UrlParsePipe implements PipeTransform {
  public transform(value: string, part?: keyof URL): string {
    if (!value) {
      return;
    }

    if (value.includes('redir.opoint')) {
      // Example:
      // http://redir.opoint.com/?url=https://shifter.no/nyheter/her-er-8-norske-engleinvestorer-som-er-klare-f
      // Gives you shifter.no
      const regex = /url=(?:https?:\/\/)?(?:www\.)?([^/]+)/;

      const prettySource = value.match(regex);
      if (prettySource) {
        return prettySource[1];
      }
    }

    // Just gives host
    const url = new URL(value);
    if (part) {
      const res = url[part];
      return typeof res === 'string' ? res : '';
    } else {
      return url.host;
    }
  }
}
